import getCdnUrl from '../../../helpers/get-cdn-url';

const MexicoFlagIcon = getCdnUrl(
  '/common_assets/assets/icons/mexico_flag_icon.svg',
);

export default MexicoFlagIcon;
